import type { AgentSkill } from '../../../../api/agent-skills';

export function isSkillReadOnly(
  skill: AgentSkill,
  { currentUserId, isAdmin }: { currentUserId: string | null; isAdmin: boolean },
): boolean {
  if (skill.isBuiltIn) return true;
  if (skill.scope === 'tenant') return !isAdmin;
  if (skill.scope === 'template' && currentUserId && skill.createdBy !== currentUserId) return true;
  return false;
}
